/**
 * @public
 */ export var PlayerType = /*#__PURE__*/ function(PlayerType) {
    PlayerType["Aamp"] = "Aamp";
    PlayerType["Android"] = "AndroidTV";
    PlayerType["WebMaf"] = "WebMaf";
    PlayerType["YouView"] = "YouView";
    PlayerType["Chromecast"] = "Chromecast";
    PlayerType["Shaka"] = "Shaka";
    PlayerType["DualPlayer"] = "DualPlayer";
    PlayerType["HtmlVideo"] = "HtmlVideo";
    PlayerType["Theo"] = "Theo";
    PlayerType["Tape"] = "Tape";
    return PlayerType;
}({});

//# sourceMappingURL=player-type.js.map